import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Plus } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { LinkButton, Typography } from '@lyearn/ui';

export interface AddFilterProps {
  onClick: () => void;
  classes?: {
    icon?: string;
    label?: string;
  };
}

function AddFilter({ onClick, classes }: AddFilterProps) {
  const { t } = useTranslation();

  return (
    <LinkButton
      className="group pt-4 px-6 text-icon-secondary"
      startIcon={<Plus className={classes?.icon} />}
      onClick={onClick}>
      <Typography
        className={cn('group-hover:text-link-internal-hover', classes?.label)}
        color="text-text-placeholder"
        variant="body-short-01">
        {t('Group:Editor.AddCondition')}
      </Typography>
    </LinkButton>
  );
}

export default AddFilter;
